import { createUserManager } from 'redux-oidc'

const userManagerConfig = {
  client_id: 'RaaS',
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }/callback.html`,
  response_type: 'code',
  scope:
    'openid profile cobalt.restapi.casemanagement cobalt.restapi.docgen idaas custom.profile offline_access raas-api-read',
  authority: window.APP_CONFIG.AUTHORITY,
  silent_redirect_uri: `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ''}/silent.html`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
}

const UserManager = createUserManager(userManagerConfig)

export enum UserRoles {
  SuperAdmin = 'SUPER_ADMIN',
  Admin = 'BAL_ADMIN',
  KmAdmin = 'KM_TEAM',
  Attorney = 'BAL_MANAGER',
  Assistant = 'BAL_ASSISTANT',
  CaseCountryManager = 'COUNTRY_CASE_MANAGER',
  HrLead = 'HR_LEAD',
  HrContact = 'HR_CONTACT',
  NetworkPartnerL1 = 'NETWORK_PARTNER_L1',
  NetworkPartnerL2 = 'NETWORK_PARTNER_L2',
  NetworkPartnerL3 = 'NETWORK_PARTNER_L3',
}

export const redirectWhenNotAllowed = (user: any): boolean => {
  if (!user || !user.userType) {
    return false
  }
  if (!hasPermittedRole(user)) {
    return true
  }

  window.location.replace(window.APP_CONFIG.COBALT_URI)
  return false
}

const hasPermittedRole = (user: any) => {
  const allowedRoles = [
    UserRoles.SuperAdmin,
    UserRoles.KmAdmin,
    UserRoles.Admin,
    UserRoles.Attorney,
    UserRoles.HrLead,
    UserRoles.HrContact,
    UserRoles.Assistant,
    UserRoles.CaseCountryManager,
  ]
  const allowedCustomRole = 'ELEVATED_COUNTRY_CASE_MANAGER'

  const userRole = user.userType.types[0]
  const hasAllowedCustomRole =
    userRole === UserRoles.CaseCountryManager &&
    user.customRoles &&
    user.customRoles.some(
      (role: { name: string }) => role.name === allowedCustomRole
    )

  return !allowedRoles.includes(userRole) && !hasAllowedCustomRole
}

export default UserManager
